//core
import React, {useRef, useEffect, useContext, useState} from "react";
import { LinearProgress } from "@mui/material";
import Lottie from "lottie-react";
import {useSelector} from "react-redux";

//styles
import { useStyles } from "./styles";

//img
import { BRAND, TITLE } from "../../../api";

//context
import { ThemeContext } from "../MuiTheme/context";

//branding
import { selectBrandingImages } from "../../../store/common/configuration/selectors";
import { getBrandingImageUrl } from "../../../helpers/brandingHelpers";

//afft loader
import afftAnimation from "./data/afft.json";
import grpAnimation from "./data/grp.json";
//import batAnimation from "./data/bat.json";

const AppLoader: React.FC = () => {
  const styles = useStyles();
  const lottieRef = useRef<any>(null);
  const context = useContext(ThemeContext);
  const brandingImages = useSelector(selectBrandingImages);

  const loaderLight = getBrandingImageUrl(brandingImages, 'loader_light');
  const loaderDark = getBrandingImageUrl(brandingImages, 'loader_dark');
  const [logoExists, setLogoExists] = useState<boolean | null>(null);
  const [logoSolidExists, setLogoSolidExists] = useState<boolean | null>(null);

  const logoSrc = `/assets/images/logo/${BRAND}/logo-large.svg?v=1.125`;
  const logoSolidSrc = `/assets/images/logo/${BRAND}/logo-solid.svg?v=1.125`;

  useEffect(() => {
    const img = new Image();
    img.onload = () => setLogoExists(true);
    img.onerror = () => setLogoExists(false);
    img.src = logoSrc;

    const imgSolid = new Image();
    imgSolid.onload = () => setLogoSolidExists(true);
    imgSolid.onerror = () => setLogoSolidExists(false);
    imgSolid.src = logoSolidSrc;
  }, [logoSrc, logoSolidSrc]);

  useEffect(() => {
    if (lottieRef.hasOwnProperty('current') && !!lottieRef.current) {
      if (BRAND === 'bat') {
        lottieRef?.current.setSpeed(6);
      } else {
        lottieRef?.current.setSpeed(4);
      }
    }
  }, [lottieRef]);

  const renderLoaderImage = () => {
    if (loaderLight || loaderDark) {
      const src = (context.darkMode && loaderDark ? loaderDark : loaderLight || loaderDark) as string;
      return <img src={src} alt={TITLE}/>;
    }
    if (BRAND === 'afft') {
      return <Lottie animationData={afftAnimation} loop={true} />;
    }

    if (BRAND === 'grp') {
      return <Lottie lottieRef={lottieRef} animationData={grpAnimation} loop={true} />;
    }
    if (context.darkMode) {
      if (logoSolidExists) {
        return <img src={logoSolidSrc} alt={TITLE}/>;
      }
      return null;
    }

    if (logoExists) {
      return <img src={logoSrc} alt={TITLE}/>;
    }
    return null;
  };

  return (
    <div className={styles.loader}>
      <div className={`${styles.logo} ${BRAND === 'bat' ? styles.large : ''}`}>
        {renderLoaderImage()}
      </div>
      <div className={styles.progress}>
        <LinearProgress />
      </div>
    </div>
  );
};

export default AppLoader;
